/**
 * Nextrip¹ floating WhatsApp — entrance + attention pulse.
 * Never preventDefault. Never breaks a valid wa.me href.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SAFE_PREFIX = 'https://wa.me/201092901540';
  var SAFE_HREF =
    'https://wa.me/201092901540?text=' +
    encodeURIComponent("Hello Nextrip1 👋\nI’d like to learn more about your travel membership and services.");

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function init(btn) {
    if (!btn || btn.dataset.n1WaInit === 'true') return;
    btn.dataset.n1WaInit = 'true';

    var href = (btn.getAttribute('href') || '').trim();
    if (href.indexOf(SAFE_PREFIX) !== 0) {
      btn.setAttribute('href', SAFE_HREF);
    }

    function markReady() {
      btn.classList.add('is-ready');
    }

    function pulseOnce() {
      if (document.hidden || !btn.classList.contains('is-ready')) return;
      btn.classList.remove('is-pulsing');
      void btn.offsetWidth;
      btn.classList.add('is-pulsing');
      window.setTimeout(function () {
        btn.classList.remove('is-pulsing');
      }, 950);
    }

    if (REDUCED) {
      markReady();
      return;
    }

    window.setTimeout(function () {
      markReady();
      window.setTimeout(pulseOnce, 420);
    }, 1000);

    window.setInterval(pulseOnce, 12000);
  }

  ready(function () {
    document.querySelectorAll('[data-nextrip-whatsapp], a.nextrip-whatsapp').forEach(init);
  });

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-nextrip-whatsapp], a.nextrip-whatsapp').forEach(function (el) {
      el.dataset.n1WaInit = '';
      init(el);
    });
  });
})();
